import { get, patch, post } from "./api";

export const fetchPPLList = () => {
  const url = `/api/v2/industryinsightsppl/`;
  return get(url);
};

export const triggerInsightCalculation = (selectedMonth) => {
  const url = `/api/v2/calcindustryinsights/${selectedMonth}/`;
  return post(url);
};

export const triggerRevenueCalculation = (selectedMonth) => {
  const url = `/api/v2/calcrevenue/${selectedMonth}/`;
  return post(url);
};

export const fetchPPLData = (insight_id) => {
  const url = `/api/v2/industryinsightsppl/${insight_id}/`;
  return get(url);
};

export const patchPPLData = (insight_id, data) => {
  return patch(
    `/api/v2/industryinsightsppl/${insight_id}/`,
    data,
    "multipart/form-data"
  );
};

export const fetchCustomerData = (params) => {
  const url = `/api/v2/insightcustomers/`;
  return get(url, params);
};

export const patchCustomerData = (revenue_id, data) => {
  return patch(
    `/api/v2/insightcustomers/${revenue_id}/`,
    data,
    "multipart/form-data"
  );
};

export const getInsightData = (id, performanceGroup, revenueGroup, signal) => {
  const url = `/api/v2/customers/${id}/industryinsights/${performanceGroup}/${revenueGroup}`;
  return get(url, {}, false, signal, true);
};
